import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgCloneSeries(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 9.01v9a2.001 2.001 0 01-1.851 1.994l-.15.005L7 20.001V21l-3-2 3-2v1l10 .01V10l2-.99zM15 14v2H9v-2h6zm2-11l3 2-3 2V6H7v8.01L5 15V6a2 2 0 011.85-1.994L7 4h10V3zm-2 8v2H9v-2h6zm0-3v2H9V8h6z"
      />
    </svg>
  );
}

export default tombacIcon('CloneSeries')(SvgCloneSeries);
